<template lang="pug">
  .literature-search(v-bind:class="{'highlight': !searchItems.length}")
    header.highlight.page-header.space--bottom
      .constrained
        .space
          h1.visuallyhidden {{ $t('SEARCH_RESEARCH_LITERATURE') }}
          form(@submit.stop.prevent="searchString")
            label(v-bind:for="'searchfield' + _uid") {{ $t('SEARCH_RESEARCH_LITERATURE') }}
            .input-group
              .input-group__input
                input(v-bind:id="'searchfield' + _uid" v-model="searchString" size="70" type="search" autofocus)
              .input-group__btn
                button.btn.btn--primary(type="submit")
                  i.icon.icon--search-turquise40-24
    .literature-search__content.constrained.space--bottom--large(v-if="searchItems")
      transition(name="transition--fade" mode="out-in")
        div(v-if="searchItems.length")
          .result-view
            transition(name="fade")
              .result-view__loader(v-if="isLoading")
                .result-view__loader__text
                  .center
                    img(src="/img/loader-literature-66.gif" width="66" height="66" alt="")
                  .center {{ $t('LOADING') }}
            .alist--left
              .facet(v-for="(facets,index) in searchFacets")
                div(v-if="facets.buckets && facets.buckets.length")
                  h2 {{ $t(index.toUpperCase()) }}
                  ul.item-list
                    li(v-for="(facet,innerIndex  in facets.buckets")
                      div.space--micro
                        input.h-space--right--small(type='checkbox' @change="setFilter($event, index, facet.key)" v-bind:id="'facet__' + facet.key" v-bind:checked="filterIsChecked(index, facet.key)")
                        label(v-bind:for="'facet__' + facet.key")
                          .right.tag(style="margin-top: 2px;") {{facet.doc_count}}
                          span(v-if="index === 'language'") {{ $t(getLanguageCode(facet.key).name) }}
                          span(v-else) {{ facet.key.charAt(0).toUpperCase() + facet.key.slice(1) }}

            .alist--right
              .right.tag(style="margin-top: 2px;") {{ searchItems.length }}
              h2(style="margin-top: 0;") {{ $t('RESULTS') }}
              ul.item-list(style="margin-top: 0;")
                li(v-for="(item, index) in items")
                  a.item-list__item.item-list__item--large.item.media(v-bind:href='item.url' )
                    .media__img(v-if="item.image")
                      img.item__img.search-result__img(v-bind:src='item.image')
                    .media__bd
                      span.tag(v-bind:class="'tag--' + item.type.toLowerCase()") {{ $t(item.type.toUpperCase()).toUpperCase() }}
                      div.item__pretitle(v-if="item.hasOwnProperty('publication') && item.publication != ''") {{ item.publication }}
                      h3.item__title(itemprop='name') {{ item.title }}
                      div.item__subtitle(v-if="item.hasOwnProperty('subtitle') && item.subtitle != ''") {{ item.subtitle }}
                      div
                        span.tag {{ item.publicationYear }}
                        span.tag(v-for="language in item.language" v-bind:title="$t(getLanguageCode(language).name)") {{ getLanguageCode(language).code }}
                        span.tag.tag--transparent {{ item.authors.join(', ') }}
                      .item__intro.item__intro--overflow(v-html="unescape(item.description)")
              .pagination(v-if="totalHits > hitsPerPage")
                .pagination__prev
                  button(v-bind:disabled="pageOffset == 0" @click="pageOffset -= hitsPerPage") {{ $t('PREVIOUS') }}
                .pagination__next
                  button(v-bind:disabled="(pageOffset + hitsPerPage) >= totalHits" @click="pageOffset += hitsPerPage") {{ $t('NEXT') }}
                ul.pagination__results
                  li(v-for="paginationItem in paginationItems")
                    span(v-if="paginationItem.hasOwnProperty('separator') && paginationItem.separator") ...
                    button.pagination__btn(v-else @click="pageOffset = paginationItem.offset" v-bind:class="{'pagination__btn--active': paginationItem.offset == pageOffset}") {{ paginationItem.name }}
        div(v-else-if="isLoading")
          .center
            img(src="/img/loader-literature-66.gif" width="66" height="66" alt="")
          .center.spacing
            span {{ $t('LOADING') }}
        div(v-else-if="!isTyping && searchString !== ''") {{ $t('NO_RESULTS') }}
        .center(v-else)
          img(src="/img/search-background.png" alt="")
    .constrained.center.space--bottom
      ul.inline-list.space--top--small
        li
          a.novisited(href='/literature/categories') {{ $t('CATEGORIES') }}
        li
          a.novisited(href='/literature/authors') {{ $t('AUTHORS') }}
        li(v-if="aboutPageTitle && aboutPageUrl")
          a.novisited(v-bind:href='aboutPageUrl') {{ aboutPageTitle }}
</template>

<script>
import debounce from 'debounce'
import axios from 'axios'
import _ from 'underscore'
import qs from 'qs'
import Vue from 'vue'

export default {
  name: 'search',
  props: {
    aboutPageTitle: {
      type: String,
      default: null
    },
    aboutPageUrl: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      filter: {},
      filterKeys: ['category', 'language'],
      hitsPerPage: 10,
      initLoad: true,
      isLoading: false,
      isTyping: false,
      pageOffset: 0,
      searchFacets: [],
      searchItems: [],
      searchString: '',
      totalHits: 0
    }
  },
  computed: {
    paginationItems() {
      const iPaginationCount = this.paginationTotal
      const iOffset = this.pageOffset
      const iMaxPages = 4
      let aPaginationItems = []
      for (var i = 0; i < iPaginationCount; i++) {
        aPaginationItems.push({
          offset: i * this.hitsPerPage,
          name: i + 1
        })
      }

      if( iPaginationCount > 7 && iOffset + iMaxPages < iPaginationCount ) {
        const iOffsetStart = iOffset + ( iOffset == 0 ? 5 : iOffset == 1 ? 4 : iOffset == 2 ? 3 : 2 )
        aPaginationItems.splice(iOffsetStart, (iPaginationCount - iOffsetStart - 1), {
          separator: true
        })
      }

      if( aPaginationItems.length > 7 && iOffset - 2 > 0 ) {
        const iOffsetEnd = iOffset - ( iPaginationCount - iOffset == 1 ? 5 : iPaginationCount - iOffset == 2 ? 4 : iPaginationCount - iOffset == 3 ? 3 : 2 )
        aPaginationItems.splice(1, iOffsetEnd, {
          separator: true
        })
      }

      return aPaginationItems
    },
    paginationTotal() {
      return Math.ceil(this.totalHits / this.hitsPerPage)
    },
    items() {
      return this.searchItems.slice(this.pageOffset, this.pageOffset + this.hitsPerPage)
    },
    query() {
      let query = {}
      let filter = {}
      const filterKeys = Object.keys(this.filter)

      if( this.searchString ) {
        query['query'] = this.searchString
      }

      for (var i = 0; i < filterKeys.length; i++) {
        const options = this.filter[filterKeys[i]]

        if( options.length ) {
          query[filterKeys[i]] = options
        }
      }

      if( this.pageOffset > 0 ) {
        query['page'] = this.pageOffset
      }

      return query
    }
  },
  methods: {
    filterIsChecked(index, filterKey) {
      return this.filter.hasOwnProperty(index) && this.filter[index].includes(filterKey)
    },
    getLanguageCode(string) {
      const oCodeMap = {
        nb: {
          code: 'NO',
          name: 'NORWEGIAN_BOKMAAL'
        },
        nn: {
          code: 'NO',
          name: 'NORWEGIAN_NYNORSK'
        },
        se: {
          code: this.$t('SAMI').toUpperCase(),
          name: 'SAMI'
        },
        en: {
          code: 'EN',
          name: 'ENGLISH'
        },
        da: {
          code: 'DK',
          name: 'DANISH'
        },
        sv: {
          code: 'SE',
          name: 'SWEDISH'
        }
      }
      const sCode = string.slice(0, 2)

      return oCodeMap.hasOwnProperty(sCode) ? oCodeMap[sCode] : {
        code: 'NA',
        name: 'NOT_AVAILABLE'
      }
    },
    getResult: debounce(function() {
      let data = {
        searchString: this.searchString,
        fields: this.filter
      }

      this.isLoading = true
      this.isTyping = false

      data[window.csrfTokenName] = window.csrfTokenValue

      axios({
        method: 'post',
        url: '/actions/elasticSearch/search/Search',
        data: qs.stringify(data),
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then(response => {
        this.isLoading = false

        if( response.data ) {

          //console.log(response.data)
          // Don't overwrite pageoffset unless the user has actually changed the query
          // If not changed it will be 0 or the offset in the path is used
          this.pageOffset = this.initLoad ? this.pageOffset : 0
          this.searchItems = response.data.result.data

          this.searchFacets = response.data.result.facet
          this.totalHits = response.data.result.totalHits
          this.initLoad = false
        }

      })
      .catch(error => {
        this.isLoading = false
        console.error(error);
      });


    }, 300),
    setFilter(event, index, value) {

      if( event.target.checked ) {
        if(this.filter[index]){

        }
        else{
          //this.filter[index] = [];
          Vue.set(this.filter, index, [])
        }
        this.filter[index].push(value);

      } else if (this.filter.hasOwnProperty(index)) {
        const iFilterIndex = this.filter[index] && this.filter[index].findIndex(filter => filter == value)

        if( iFilterIndex > -1 ) {
          this.filter[index].splice(iFilterIndex, 1)
        }
      }
      this.getResult();

    },
    unescape(string) {
      return _.unescape(string)
    }
  },
  mounted() {

    // Class used to set the blue illustration backgrund when search is empty
    document.body.className = (document.body.className ? document.body.className + ' ' : '') + 'literature-page'

    // Get the query data from the path (vue router instance) and apply the settings
    const query = this.$router.currentRoute.query
    const queryKeys = Object.keys(query)
    let filter = {}
    if( queryKeys.length ) {

      for (var i = 0; i < queryKeys.length; i++) {
        const key = queryKeys[i]

        // Add the search string if any
        if( key === 'query' ) {
          this.searchString = query.query
        // Add the page offset if any
        } else if( key === 'page' ) {
          this.pageOffset = parseInt(query[key])
        // Else add the props to the filter
        } else if( key !== 'query' && key !== 'page' ) {

          // If the filter key doesnt exist create an array with the value
          if( !filter[key] ) {
            filter[key] = [query[key]]
          // Else push the value to the existing array
          } else {
            filter[key].push(query[key])
          }
        }
      }

      this.filter = filter
    }

  },
  watch: {
    query() {
      this.$router.push({query: this.query})
    },
    searchString() {
      this.isTyping = true
      this.getResult()
    }
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/search.vue